import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ItemActionsIcon } from '../../../../../components/ItemActionsIcon/ItemActionsIcon';
import classes from './receipt-top-bar.module.scss';

export type ReceiptTopBarProps = {
    guestName: string | null;
    tableLabel: string;
    isManager: boolean;
    isDiscountInFlight: boolean;
    onPrint: () => void;
    onActions: () => void;
    onEditGuestName: () => void;
    // Restore mode relabels the actions tab (פעולות → שחזר שולחן) without forking the component.
    actionsLabel?: string;
    actionsIcon?: IconProp;
    guestNameReadOnly?: boolean;
    // Quick-charge bill: only ביטול (via actions) is allowed — hide reprint + guest-name.
    isQuickCharge?: boolean;
};

const ReceiptTopBarComponent: React.FC<ReceiptTopBarProps> = ({
    guestName,
    tableLabel,
    isManager,
    isDiscountInFlight,
    onPrint,
    onActions,
    onEditGuestName,
    actionsLabel = 'פעולות',
    actionsIcon,
    guestNameReadOnly = false,
    isQuickCharge = false,
}) => {
    const displayGuestName = guestName ?? tableLabel;

    return (
        <div className={classes.receiptBar} role="toolbar" aria-label="פעולות חשבון">
            {!isQuickCharge && (
                <button
                    type="button"
                    className={classes.receiptTab}
                    onClick={onPrint}
                    aria-label="הדפס"
                    data-testid="receipt-topbar-print"
                >
                    <span className={classes.receiptTabIcon}>
                        <img src="/recieptprint.png" alt="" />
                    </span>
                    <span className={classes.receiptTabLabel}>הדפס</span>
                </button>
            )}
            <button
                type="button"
                className={classes.receiptTab}
                onClick={onActions}
                disabled={isDiscountInFlight}
                aria-label="פעולות"
                data-testid="receipt-topbar-actions"
            >
                <span className={classes.receiptTabIcon}>
                    {actionsIcon ? <FontAwesomeIcon icon={actionsIcon} /> : <ItemActionsIcon />}
                </span>
                <span className={classes.receiptTabLabel}>{actionsLabel}</span>
            </button>
            {!isQuickCharge && (
                <button
                    type="button"
                    className={`${classes.receiptTab} ${classes.guestNameTab}`}
                    onClick={onEditGuestName}
                    disabled={guestNameReadOnly}
                    aria-label="שנה שם לקוח"
                    data-testid="receipt-topbar-guest-name"
                >
                    <span className={classes.guestNameValue}>{displayGuestName}</span>
                    <span className={classes.guestNameSubLabel}>שם לקוח</span>
                </button>
            )}
        </div>
    );
};

export const ReceiptTopBar = React.memo(ReceiptTopBarComponent);
